import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import "./Common_Tour_Card.css";
import Common_Btn_Yellow from "../common_btn_yellow/Common_Btn_Yellow";

function CommonTourCard({
  data,
  title,
  location,
  duration,
  places,
  activity,
  price,
  img,
}) {
  const navigate = useNavigate();

  const handleBookNow = () => {
    navigate(`/location-inner-page/${data?.id}`);
  };

  return (
    <div className="tour-card">
      {/* <div className="tour-img-wrapper"> */}
      <div className="tour-img">
        <img src={img} alt={title} />
      </div>
      {/* </div> */}

      <div className="tour-content">
        <h5>{title}</h5>

        <p className="tour-meta">
          <FontAwesomeIcon icon={faLocationDot} className="meta-icon" />
          {location} | {duration} | {places} places | {activity} activities
        </p>

        <div className="tour-footer">
          <h4>
            {price} <span>Adult</span>
          </h4>

          <Common_Btn_Yellow text="Book Now" onClick={handleBookNow} />
        </div>
      </div>
    </div>
  );
}

export default CommonTourCard;
